// extracted by mini-css-extract-plugin
export default {"checkbox":"OnboardingCheckbox_checkbox__guA1A"};